import { createContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';

export const HoneycombTruncationMode = createContext<TruncationMode>('middle');
